@if (notes?.length) {
  <h2 mat-dialog-title class="dialog-title">{{ notes[$currentPage()]?.title }}</h2>
  <mat-dialog-content>
    @if (isPicture) {
      <div class="image" [style.background-image]="'url(' + mediaSrc + ')'"></div>
    } @else if (isIframe && $iframeUrl()) {
      <supademo [iframeTitle]="iframeTitle" [iframeUrl]="$iframeUrl()" />
    }

    @if (isPicture) {
      <p class="text">
        <!-- do not exceed 308 characters (empty spaces are counted) -->
        {{ notes[$currentPage()].text }}
      </p>
    }
    @if (notes.length > 1) {
      <div class="ellipses-container">
        @for (note of notes; track $index) {
          <input
            type="radio"
            [value]="$index"
            [ngClass]="{ ellipse: true, 'unselected-ellipse': $index !== $currentPage() }"
            (click)="$currentPage.set($index)" />
        }
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    @if (isDemoTour) {
      <button mat-button color="primary" class="step-button" [disabled]="true">
        {{ 'COMMON.PREVIOUS' | translate }}
      </button>
      <button mat-button color="accent" cdkFocusInitial class="step-button" (click)="runDemoTour()">
        {{ submitText | translate }}
      </button>
    } @else {
      @if (dialogRef) {
        <button mat-button color="primary" class="step-button" (click)="onPrevious()">
          {{ previousText | translate }}
        </button>
        <button mat-button color="accent" cdkFocusInitial class="step-button" (click)="onNext()">
          {{ submitText | translate }}
        </button>
      } @else if (notes.length > 1) {
        <button
          mat-button
          color="primary"
          class="step-button"
          (click)="onPrevious()"
          [disabled]="this.$currentPage() === 0">
          {{ 'COMMON.PREVIOUS' | translate }}
        </button>
        <button
          mat-button
          color="accent"
          cdkFocusInitial
          class="step-button"
          (click)="onNext()"
          [disabled]="$currentPage() === notes?.length - 1">
          {{ 'COMMON.NEXT' | translate }}
        </button>
      }
    }
  </mat-dialog-actions>
}
